<template>
  <div class="container-fluid regulatory-updates-sub-menu">
    <div class="col-xs-12 p-0 mt-25 mb-20">
      <div class="page-header-title col-xs-12 col-sm-4 col-md-5 p-0 col-lg-6">Regulatory Watch</div>
      <div class="col-xs-12 col-sm-8 col-md-7 col-lg-6 p-0 d-flex-sm-end xs-mt-20">
        <div
          class="search-container flex-50"
          v-if="permissions.includes('REG_WTCH_REG_UPD_SEARCH_FOR_UPDATE')"
        >
          <search-box v-model="searchRegulatory" @getList="searchReg()"></search-box>
        </div>
        <div class="heading-sub-menu" v-if="permissions.includes('REG_WTCH_REG_UPD_PREFERENCES')">
          <span class="btn emergo-blue-button" @click="OpenRegWatchSettings">Manage Countries</span>
          <el-popover
            class="ml-10 width-400 width-300"
            placement="top-start"
            trigger="click"
            width="310"
            @show="infoActive = true"
            @hide="infoActive = false"
          >
            <div class="limit_popover_txt">
              Regulatory updates are displayed based on <br />countries selected under Account
              Settings.<br />See all countries or customize based on<br />your market interest.
            </div>
            <!-- <template #reference> -->
            <img
              class="info-img"
              src="/static/images/icons/info_icon.svg"
              v-if="!infoActive"
              alt="info-icon"
              slot="reference"
            />
            <img
              class="info-img"
              src="/static/images/icons/info_icon_active.svg"
              v-if="infoActive"
              alt="infoactive-icon"
              slot="reference"
            />
            <!-- </template> -->
          </el-popover>
        </div>
      </div>
    </div>
    <div
      class="col-xs-12 regulatory-label new-count-pl"
      v-if="searchRegResultCount.length > 0 || this.isFromGlobalSearch"
    >
      <p>{{ filteredRegulatoryLength }} Result(s) found...</p>
    </div>
    <div class="col-xs-12 new-count-pl pb-20">
      <div
        class="col-xs-12 col-sm-8 col-lg-9 p-0 heading-sub-menu"
        v-if="permissions.includes('REG_WTCH_REG_UPD_NEW')"
      >
        {{ headerValues.newCount }} New Regulatory Updates
      </div>
    </div>
  </div>
</template>
<script>
import { Popover } from 'element-ui';
import EventBus from '../../utils/event-bus';
// import BasePopover from '../Common/BasePopover.vue';
import SearchBox from '../UIComponents/SearchBox.vue';

export default {
  props: {
    permissions: Array,
    headerValues: Object,
    searchRegulatoryText: String,
    isFromGlobalSearch: Boolean
  },

  components: {
    SearchBox,
    // BasePopover,
    'el-popover': Popover
  },

  data() {
    return {
      infoActive: false,
      searchRegulatory: this.searchRegulatoryText,
      searchRegResultCount: '',
      activeName: '',
      filteredRegulatoryLength: 0
    };
  },
  watch: {
    searchRegulatoryText: {
      handler(newValue) {
        if (newValue.length) {
          this.searchRegulatory = newValue;
          this.searchReg();
        }
      },
      immediate: true
    }
  },
  methods: {
    OpenRegWatchSettings() {
      EventBus.$emit('notificationSettings', 'notifications');
    },
    searchReg() {
      this.searchRegResultCount = this.searchRegulatory;
      this.$emit('filterSearchRegulatory', this.searchRegulatory);
    },
    resetSearch() {
      this.searchRegulatory = '';
      this.searchReg();
    }
  },
  mounted() {
    this.$root.$on('filteredRegulatoryLength', (data) => {
      this.filteredRegulatoryLength = data;
    });
  }
};
</script>
<style lang="scss" scoped>
.regulatory-updates-sub-menu {
  padding-left: 25px;
}
.heading-sub-menu {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
}
.new-count-pl {
  padding-left: 0px;
}
.regulatory-label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 28px;
}
.search-box {
  &:hover {
    box-shadow: inset 0 0 0px 1px #85b7d9;
  }
  padding: 18px 72px 18px 20px;
}
@media only screen and (max-width: 767px) {
  .xs-mt-20 {
    margin-top: 20px;
  }
}
@media screen and (min-width: 768px) {
  .sm-p-0 {
    padding: 0px;
  }
}
@media only screen and (max-width: 576px) {
  .d-flex-sm-end {
    flex-direction: column;
    row-gap: 20px;
  }
}
</style>
